export default {
	syncFailures: {
		subtitle: 'Überblick über die Datenübertragung aus dem ERP-System',
		tabOverview: 'Übersicht',
		tabFailures: 'Fehler',
		tabUpdates: 'Letzte Aktualisierungen',
		filterModule: 'Modul',
		lastUpdateAt: 'Letzte Aktualisierung: {date}',
		colModule: 'Modul',
		colErpId: 'ERP-Nr.',
		colProblem: 'Problem',
		colRecord: 'Datensatz',
		colChangedFields: 'Geänderte Felder',
		colTime: 'Zeitpunkt',
		copyErpId: 'ERP-Nr. kopieren',
		copiedErpId: 'ERP-Nr. {id} in die Zwischenablage kopiert',
		detailsTitle: 'Technische Details',
		detailsReason: 'Originalmeldung',
		detailsShowReason: 'Originalmeldung anzeigen',
		detailsHideReason: 'Originalmeldung ausblenden',
		detailsCode: 'Fehlercode',
		detailsSyncRun: 'Sync-Lauf',
		detailsInternalId: 'Interner Eintrag',
		detailsErpInternalId: 'ERP-interne ID',
		retryRow: 'Erneut versuchen',
		retryAll: 'Alle (gefiltert) erneut versuchen',
		retryPending: 'Retry ausstehend',
		retryAllCount: 'Alle {count} erneut versuchen',
		retryConfirmTitle: 'Sync-Fehler zur Wiederholung markieren',
		retryConfirmBodyRow:
			'Soll dieser Sync-Eintrag beim nächsten Sync-Lauf erneut versucht werden?',
		retryConfirmBodyBulk:
			'Sollen {count} Sync-Einträge beim nächsten Sync-Lauf erneut versucht werden? Die Übertragung wirkt erst beim nächsten Sync-Lauf, nicht sofort.',
		retrySuccessRow: '{count} Eintrag für erneuten Versuch markiert.',
		retrySuccessBulk: '{count} Einträge für erneuten Versuch markiert.',
		showChain: 'Zusammenhang anzeigen',
		chainTitle: 'Fehler-Zusammenhang',
		chainCausedBy: 'Verursacht durch',
		chainCurrent: 'Dieser Fehler',
		chainCauses: 'Verursacht Folgefehler',
		chainSiblings: 'Zugehörige Einträge',
		chainEmpty: 'Dieser Fehler steht mit keinen anderen Fehlern in Verbindung.',
		truncationHint:
			'Es werden die neuesten {count} Einträge angezeigt. Nutzen Sie die Filter, um die Auswahl einzugrenzen.',
		diffOld: 'Vorher',
		diffNew: 'Nachher',
		diffEmpty: '(leer)',
		requestBodyTitle: 'Übermittelte Daten',
		versionNotice:
			'Für vollständige Sync-Fehlerdaten ist mindestens Sync-Version {version} erforderlich. Diese Version wird derzeit ausgerollt.',
		fields: {
			hp_id: 'ERP-Nr.',
			person_id: 'Person',
			building_id: 'Liegenschaft',
			unit_id: 'Einheit',
			description: 'Beschreibung',
			type_id: 'Art',
			zip: 'PLZ',
			city: 'Ort',
			country: 'Land',
			street: 'Straße',
			name: 'Name',
			number: 'Nummer',
			created: 'Erstellt',
			updated: 'Aktualisiert',
			deleted: 'Gelöscht',
		},
		selfHealingHint: 'Einträge werden automatisch bereinigt',
		selfHealingShow: 'anzeigen',
		selfHealingHide: 'ausblenden',
		emptyFailuresTitle: 'Keine Sync-Fehler',
		emptyFailuresText:
			'Alle Daten wurden erfolgreich aus dem ERP-System übertragen.',
		emptyUpdates: 'Keine Aktualisierungen aufgezeichnet.',
		emptyFiltered: 'Keine Einträge für die aktuelle Filterauswahl.',
		analysis: {
			dependency: {
				title: 'Wartet auf verknüpften Datensatz',
				action:
					'Der verknüpfte Datensatz muss zuerst im ERP-System vorhanden und übertragen sein. Danach wird dieser Eintrag automatisch nachgezogen.',
				actionWithDep:
					'Der verknüpfte Datensatz {dependency} muss zuerst im ERP-System vorhanden und übertragen sein. Danach wird dieser Eintrag automatisch nachgezogen.',
			},
			blocked: {
				title: 'Durch verknüpfte Daten blockiert',
				action:
					'Der Datensatz wird im Portal noch verwendet und kann daher nicht {operation} werden. Entfernen Sie zuerst die Verknüpfung im ERP-System; danach wird die Übertragung automatisch wiederholt.',
				actionRemoved:
					'Der Datensatz konnte nach mehreren Versuchen nicht {operation} werden, weil er noch verwendet wird, und wurde aus der Warteschlange entfernt. Entfernen Sie die Verknüpfung im ERP-System und bearbeiten Sie den Datensatz erneut, damit er neu übertragen wird.',
			},
			self_healing: {
				title: 'Wird automatisch bereinigt',
				action:
					'Kein Handlungsbedarf: Der Datensatz ist im Portal nicht (mehr) vorhanden. Der Eintrag wird beim nächsten Sync automatisch bereinigt.',
			},
			missing_file: {
				title: 'Verknüpfte Datei nicht gefunden',
				action:
					'Die mit diesem Eintrag verknüpfte Datei ist im Dateisystem nicht (mehr) vorhanden. Bitte prüfen Sie, ob die Datei im ERP-System bzw. Archiv existiert. Kein Support erforderlich.',
			},
			temporary: {
				title: 'Vorübergehendes Problem',
				action:
					'Vorübergehendes Server- oder Verbindungsproblem. Die Übertragung wird automatisch wiederholt, kein Handlungsbedarf.',
			},
			invalid_data: {
				title: 'Daten ungültig oder unvollständig',
				action:
					'Die Daten wurden vom Portal abgelehnt. Bitte prüfen und korrigieren Sie den Datensatz im ERP-System (z. B. fehlende Pflichtfelder). Abgelehnte Felder sind ggf. unten aufgeführt.',
			},
			validationErrorsTitle: 'Abgelehnte Felder',
			conflict: {
				title: 'Möglicher Datenkonflikt',
				action:
					'Möglicherweise ein Duplikat. Bitte prüfen Sie den Datensatz im ERP-System auf doppelte Einträge.',
			},
			auth: {
				title: 'Anmeldung des Sync-Dienstes fehlgeschlagen',
				action:
					'Der Sync-Dienst konnte sich nicht anmelden oder hat keine Berechtigung. Bitte kontaktieren Sie den Support.',
			},
			config: {
				title: 'Technisches Konfigurationsproblem',
				action:
					'Ein internes Konfigurationsproblem verhindert die Übertragung. Bitte kontaktieren Sie den Support mit den technischen Details (siehe unten).',
			},
			unknown: {
				title: 'Übertragungsfehler',
				action:
					'Die Übertragung ist fehlgeschlagen. Bitte sehen Sie sich die technischen Details an. Tritt der Fehler wiederholt auf, kontaktieren Sie den Support.',
			},
			operationGeneric: 'verarbeitet',
			operations: {
				Create: 'angelegt',
				Read: 'gelesen',
				Update: 'aktualisiert',
				Delete: 'gelöscht',
			},
		},
		hpIdParts: {
			building: 'Liegenschaft',
			accounting_year: 'Jahr',
			account_number: 'Konto',
			sequence_number: 'Lfd. Nr.',
			payment_part: 'Teilzahlung',
			primanota: 'Primanota',
			journal_number: 'Journal',
			line_item: 'Position',
			address_number: 'Adresse',
			email_index: 'E-Mail-Index',
		},
		modules: {
			address: 'Adresse',
			building: 'Liegenschaft',
			building_address: 'Liegenschafts-Adresse',
			unit: 'Einheit',
			role: 'Personenfunktion',
			person: 'Person',
			user: 'Benutzer',
			propertymanager: 'Objektsachbearbeiter',
			building_type: 'Liegenschaftsart',
			building_group_header: 'Liegenschaftsgruppe',
			building_group_value: 'Liegenschaftsgruppen-Wert',
			building_garage_type: 'Garagenart',
			building_heating_type: 'Heizungsart',
			building_trashbarrel_type: 'Mülltonnenart',
			building_hotwater_type: 'Warmwasserart',
			building_type_building_group_value: 'Zuordnung Liegenschaftsart – Gruppe',
			rolepermission: 'Berechtigung (Personenfunktion)',
			phonenumber: 'Telefonnummer',
			email: 'E-Mail-Adresse',
			communication_type: 'Kommunikationsart',
			document_type: 'Dokumentenart',
			document_file: 'Dokumentdatei',
			document_container: 'Dokument',
			document_building: 'Dokument-Zuordnung (Liegenschaft)',
			document_unit: 'Dokument-Zuordnung (Einheit)',
			document_person: 'Dokument-Zuordnung (Person)',
			document_cis: 'Dokument-Zuordnung (Z.I.S.)',
			document_task: 'Dokument-Zuordnung (Wiedervorlage)',
			document_craftsmantask: 'Dokument-Zuordnung (Handwerkerauftrag)',
			user_client: 'Benutzerzugang',
			team: 'Team',
			team_user: 'Team-Mitglied',
			cis: 'Z.I.S.',
			cis_building: 'Z.I.S.-Zuordnung (Liegenschaft)',
			cis_unit: 'Z.I.S.-Zuordnung (Einheit)',
			cis_person: 'Z.I.S.-Zuordnung (Person)',
			cis_type: 'Z.I.S.-Art',
			task: 'Wiedervorlage',
			task_building: 'Wiedervorlage-Zuordnung (Liegenschaft)',
			task_unit: 'Wiedervorlage-Zuordnung (Einheit)',
			task_person: 'Wiedervorlage-Zuordnung (Person)',
			task_type: 'Wiedervorlagenart',
			craftsmantask: 'Handwerkerauftrag',
			craftsmantask_type: 'Handwerkerauftragsart',
			craftsmantask_status: 'Handwerkerauftrag-Status',
			craftsmantask_process: 'Handwerkerauftrag-Vorgang',
			craftsmantask_status_text: 'Handwerkerauftrag-Statustext',
			craftsmantask_person: 'Handwerkerauftrag-Person',
			craftsmantask_person_contact: 'Handwerkerauftrag-Kontakt',
			craftsmantask_person_type: 'Handwerkerauftrag-Personenart',
			craftsmantask_building: 'Handwerkerauftrag-Zuordnung (Liegenschaft)',
			craftsmantask_unit: 'Handwerkerauftrag-Zuordnung (Einheit)',
			craftsmantask_task: 'Handwerkerauftrag-Zuordnung (Wiedervorlage)',
			craftsmantask_cis: 'Handwerkerauftrag-Zuordnung (Z.I.S.)',
			none: 'Allgemein',
			building_group_building: 'Zuordnung Liegenschaftsgruppe – Liegenschaft',
			meter: 'Zähler',
			meter_type: 'Zählerart',
			meter_devicetype: 'Zähler-Gerätetyp',
			meter_manufacturer: 'Zähler-Hersteller',
			meter_level: 'Zählerstand',
			meter_consumption: 'Verbrauch',
			accounting_year: 'Buchungsjahr',
			account_name: 'Kontobezeichnung',
			account_balance: 'Kontosaldo',
			account: 'Konto',
			account_person: 'Konto-Zuordnung (Person)',
			journal: 'Buchung',
			vendor_account: 'Kreditorenkonto',
			invoice: 'Rechnung',
			review_document: 'Belegprüfung',
			review_document_account: 'Belegprüfung-Konto',
			review_document_account_name: 'Belegprüfung-Kontobezeichnung',
			review_document_account_balance: 'Belegprüfung-Kontosaldo',
			review_document_journal: 'Belegprüfung-Buchung',
			review_document_account_link: 'Belegprüfung-Kontoverknüpfung',
			update_request: 'Datenänderungsanfrage',
			note: 'Notiz',
			handover_protocol: 'Übergabeprotokoll',
			client: 'Mandant',
		},
	},
}
